module.exports = __webpack_public_path__ + "quote_right.8a06fedcda7a33c8acf279f52303b2dc.svg";